var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftMembershipStepEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.95 8.4375L20.6625 7.0125C20.6625 5.7375 19.6125 4.65 18.3 4.65H16.875C16.8375 4.65 16.8375 4.6125 16.8 4.6125L12.45 1.875C12.1875 1.6875 11.8125 1.6875 11.55 1.875L7.12501 4.65H5.70001C4.42501 4.65 3.33751 5.7 3.33751 7.0125L1.05001 8.4375C0.787512 8.5875 0.637512 8.85 0.637512 9.15V19.8C0.637512 21.1875 1.76251 22.275 3.11251 22.275H20.8125C22.2 22.275 23.2875 21.15 23.2875 19.8V9.15C23.3625 8.85 23.2125 8.5875 22.95 8.4375ZM21.675 9.6V10.575L20.6625 10.95V9L21.675 9.6ZM12 3.5625L13.725 4.65H10.3125L12 3.5625ZM5.70001 6.3375H7.35001H18.3C18.675 6.3375 18.975 6.6375 18.975 7.0125V11.625L11.85 14.25L5.02501 11.775V6.975C5.02501 6.6375 5.32501 6.3375 5.70001 6.3375ZM3.33751 9V11.1375L2.32501 10.7625V9.6375L3.33751 9ZM20.85 20.5875H3.15001C2.70001 20.5875 2.36251 20.2125 2.36251 19.8V12.5625L11.5875 15.9C11.6625 15.9375 11.775 15.9375 11.8875 15.9375C12 15.9375 12.075 15.9375 12.1875 15.9L21.675 12.375V19.7625C21.675 20.2125 21.3 20.5875 20.85 20.5875Z",
    fill: "#284993"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7375 9.5248H15.2625C15.7125 9.5248 16.125 9.14981 16.125 8.66231C16.125 8.17481 15.75 7.7998 15.2625 7.7998H8.7375C8.2875 7.7998 7.875 8.17481 7.875 8.66231C7.875 9.14981 8.2875 9.5248 8.7375 9.5248Z",
    fill: "#284993"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7375 12.2621H15.2625C15.7125 12.2621 16.125 11.8871 16.125 11.3996C16.125 10.9121 15.75 10.5371 15.2625 10.5371H8.7375C8.2875 10.5371 7.875 10.9121 7.875 11.3996C7.875 11.8871 8.2875 12.2621 8.7375 12.2621Z",
    fill: "#111928"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftMembershipStepEnvelope);
export default __webpack_public_path__ + "static/media/gift-membership-step-envelope.79befa76e4cf1208b4ebf59bee6e81de.svg";
export { ForwardRef as ReactComponent };